import axios from 'axios';

export default {
  fetchOrganizationalUnit({
    commit,
  }, id) {
    return axios.get(`/organizationalUnit/show/${id}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'organizationalUnit',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  saveOrganizationalUnit(_, organizationalUnit) {
    return axios.post('/organizationalUnit', organizationalUnit);
  },
};
